module.exports = __webpack_public_path__ + "static/media/code.6b402517.jpg";